import { merge } from '../../../helper';

// ----------------------------------------------------------------------------

function toBody(element: HTMLElement, config: Record<string, any> = {}): void {
    // Default Config
    const defConfig: Record<string, any> = {
        parent: 'body',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    let dropdownMenu;

    //
    element.addEventListener('show.bs.dropdown', function (evt): any {
        /*
         * // Grab the menu
         * dropdownMenu = $(evt.target).find('.dropdown-menu');
         *
         * // Detach it and append it to the body
         * defConfig.parent.appendChild(dropdownMenu.detach());
         *
         * // Grab the new offset position
         * const eOffset = $(evt.target).offset();
         *
         * // Make sure to place it where it would normally go (this could be improved)
         * dropdownMenu.css({
         *  display: 'block',
         *  top: eOffset.top + $(evt.target).outerHeight(),
         *  left: eOffset.left,
         * });
         */
    });

    //
    element.addEventListener('hide.bs.dropdown', function (evt): any {
        /*
         * $(evt.target).append(dropdownMenu.detach());
         * dropdownMenu.hide();
         */
    });
}

// ----------------------------------------------------------------------------

export { toBody };
